import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const fetchTripsManulaDone = createAsyncThunk(
  "TripManula/fetchTripsManulaDone",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/getAllTripManualDone/${id}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = await res.data.data;

      return result;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        //Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);




const TripManualDoneSlice = createSlice({
  name: "TripManula",
  initialState: {
    TripManulas: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearTripManulaState: (state) => {
      state.TripManulas = [];
      state.loading = false;
      state.error = null;
    },
  
  },
  extraReducers: {
    //fetch
    [fetchTripsManulaDone.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchTripsManulaDone.fulfilled]: (state, action) => {
      state.TripManulas = action.payload;
      state.loading = false;
    },
    [fetchTripsManulaDone.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  
  },
});
export const {  clearTripManulaState } = TripManualDoneSlice.actions;
export default TripManualDoneSlice.reducer;
